// Literal Tailwind class names (not template-built) so the JIT scanner picks
// them up - see the --color-cat-N tokens in client/src/styles/tailwind.css.
const PALETTE = [
  { bg: 'bg-cat-1/15', text: 'text-cat-1', border: 'border-cat-1', dot: 'bg-cat-1' },
  { bg: 'bg-cat-2/15', text: 'text-cat-2', border: 'border-cat-2', dot: 'bg-cat-2' },
  { bg: 'bg-cat-3/15', text: 'text-cat-3', border: 'border-cat-3', dot: 'bg-cat-3' },
  { bg: 'bg-cat-4/15', text: 'text-cat-4', border: 'border-cat-4', dot: 'bg-cat-4' },
  { bg: 'bg-cat-5/15', text: 'text-cat-5', border: 'border-cat-5', dot: 'bg-cat-5' },
  { bg: 'bg-cat-6/15', text: 'text-cat-6', border: 'border-cat-6', dot: 'bg-cat-6' },
  { bg: 'bg-cat-7/15', text: 'text-cat-7', border: 'border-cat-7', dot: 'bg-cat-7' },
  { bg: 'bg-cat-8/15', text: 'text-cat-8', border: 'border-cat-8', dot: 'bg-cat-8' },
] as const;

export function colorForJob(jobId: string) {
  let hash = 0;
  for (let i = 0; i < jobId.length; i++) hash = (hash * 31 + jobId.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length]!;
}
